<app-centre-small-opener>
  <h2 dialogTitle class="mar-b-5 pd-t-5px">{{data.title}}</h2>
  <div contentContainer class="row">
      <div class="col-lg-12 col-sm-12" style="padding: 0px;">
        <form class="col-lg-12 d-lg-flex col-sm-12 d-sm-flex">
          <!-- <div class="container" style="padding: 0px;" [style.display]="(momList!=null && momList!=undefined && momList!.length>1) ? 'block' : 'none'" >
            <div class="d-flex align-items-center">
                <mat-form-field appearance="fill">
                  <mat-select [(ngModel)]="selectedValue" name="momSelect">
                    <mat-option [value]="'select'">Select</mat-option>
                    <ng-container *ngFor="let momLst of momList">
                      <mat-option [value]="momLst.pkMomDetailId" *ngIf="momLst.momStatusCode!='A'">
                        {{momLst.momTitle}}
                      </mat-option>
                  </ng-container>
                  </mat-select>
                </mat-form-field>
            </div>
          </div> -->
            <div class="col-12" style="padding: 0px;">
              <div class="d-flex align-items-center" [style.display]="(momList!=null && momList!=undefined && momList!.length>1) ? 'block' : 'none'">
                <mat-form-field style="width: 100%;">
                  <mat-label>Select MOM</mat-label>
                  <mat-select disableOptionCentering panelClass="common-drop-down-class" [(ngModel)]="selectedValue" name="momSelect">
                    <mat-option [value]="'select'">Select</mat-option>
                    <ng-container *ngFor="let momLst of momList">
                      <mat-option [value]="momLst.pkMomDetailId" *ngIf="momLst.momStatusCode!='A'">
                        {{momLst.momTitle}}
                      </mat-option>
                  </ng-container>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="d-flex align-items-center">
                <input type="radio"  (change) = "showAddParticipants()" checked id = "participants" style="margin-right: 10px;" name="group-1" />
                <label for = "participants">Send to selected participants</label>
              </div> 
              <mat-form-field *ngIf = "particToggler" style="width: 100%;">
                <mat-label>Select the participants</mat-label>
                <mat-select disableOptionCentering panelClass="common-drop-down-class" [formControl]="toppingsControl" multiple (blur) = "callTrigger()">
              
                  <mat-select-trigger>
                    <mat-chip-listbox>
                      <mat-chip-option *ngFor="let topping of toppingsControl.value"
                        [removable]="true" (removed)="onToppingRemoved(topping)">
                        {{ topping.attendeeName }}
                        <mat-icon matChipRemove>cancel</mat-icon>
                      </mat-chip-option>
                    </mat-chip-listbox>
                  </mat-select-trigger>
              
                  <mat-option *ngFor="let topping of data.meetingResp.attendeeList" [value]="topping">{{topping.attendeeName}}</mat-option>
              
                </mat-select>
              </mat-form-field>

              <!-- <mat-form-field *ngIf = "particToggler" style="width: 100%;">
                <mat-label>Select the participants</mat-label>
                <mat-select disableOptionCentering panelClass="common-drop-down-class" [formControl]="toppingsControl" multiple (blur) = "callTrigger()">
              
                  <mat-select-trigger>
                    <mat-chip-listbox>
                      <mat-chip-option *ngFor="let topping of toppingsControl.value"
                        [removable]="true" (removed)="onToppingRemoved(topping)">
                        {{ topping.attendeeName }}
                        <mat-icon matChipRemove>cancel</mat-icon>
                      </mat-chip-option>
                    </mat-chip-listbox>
                  </mat-select-trigger>
              
                  <mat-option *ngFor="let topping of data.meetingResp.attendeeList" [value]="topping">{{topping.attendeeName}}</mat-option>
              
                </mat-select>
              </mat-form-field>
              <div class="d-flex align-items-center">
                <input type="radio"  id = "all-participants" name="group-1" style="margin-right: 10px;" (change) = "hideAddParticipants()"/>
                <label for = "all-participants">Send to all participants</label>
              </div> -->



              <!-- {{ toppingsControl.value | json }} -->
              <!-- <mat-form-field class="example-chip-list" *ngIf = "particToggler" style="padding-left: 25px;">
                <mat-label>Select the participants</mat-label>
                <mat-chip-list #chipList aria-label="Fruit selection">
                  <mat-chip
                    *ngFor="let fruit of fruits"
                    (removed)="remove(fruit)">
                    {{fruit}}
                    <button matChipRemove mat-icon-button>
                      <mat-icon style="position: relative; top: -12px; left: 0px;">cancel</mat-icon>
                    </button>
                  </mat-chip>
                  <input
                    placeholder="Participants"
                    #fruitInput
                    [formControl]="fruitCtrl"
                    [matAutocomplete]="auto"
                    [matChipInputFor]="chipList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    (matChipInputTokenEnd)="add($event)">
                </mat-chip-list>
                <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
                  <mat-option *ngFor="let fruit of filteredFruits | async" [value]="fruit">
                    {{fruit}}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field> -->
              <div class="d-flex align-items-center">
                <input type="radio"  id = "all-participants" name="group-1" style="margin-right: 10px;" (change) = "hideAddParticipants()"/>
                <label for = "all-participants">Send to all participants</label>
              </div>
            </div>
        </form>
      </div>
  </div>
  <div class="d-flex justify-content-end" actions>
      <button mat-raised-button actions color = "primary" class="button-container mar-l-8" (click) = "sendDraft()">
        SUBMIT
      </button>
      <button mat-raised-button mat-dialog-close type="reset" color = "primary" actions class="button-container mar-l-8">
        CANCEL
      </button>
  </div>
</app-centre-small-opener>
